module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o-rewards"
  }, [_c('app-navigation', {
    attrs: {
      "current-space": _vm.$t('web.rewards_results.nav_space'),
      "back-button": true
    }
  }), _vm._v(" "), _c('main', {
    staticClass: "o-rewards__main"
  }, [_c('search-bar'), _vm._v(" "), _c('rewards-navigation'), _vm._v(" "), (_vm.rewardsLoading) ? _c('loading-icon') : _c('rewards-list'), _vm._v(" "), _c('paginate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.rewardsLoading),
      expression: "!rewardsLoading"
    }],
    attrs: {
      "pagination": _vm.pagination,
      "pagingCallback": _vm.goToPage
    }
  })], 1), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5be8a6a2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/RewardsResults.vue
// module id = 537
// module chunks = 1